/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

export default function FullScreenIcon({
  width = 15,
  height = 15,
}) {
  return (
    <span
      style={{
        display: 'inline-flex',
        width,
        height,
        flexShrink: 0,
      }}
      aria-hidden
    >
      <svg width="100%" height="100%" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.33333 4C1.33333 4.36819 1.03486 4.66667 0.666667 4.66667C0.298477 4.66667 0 4.36819 0 4V1.33333C0 0.596954 0.596954 0 1.33333 0H4C4.36819 0 4.66667 0.298477 4.66667 0.666667C4.66667 1.03486 4.36819 1.33333 4 1.33333H2.27614L6.4714 5.52859C6.73175 5.78894 6.73175 6.21105 6.4714 6.4714C6.21105 6.73175 5.78894 6.73175 5.52859 6.4714L1.33333 2.27614V4Z" fill="#3C5873" />
        <path d="M13.3333 10.6667C13.3333 10.2985 13.6318 10 14 10C14.3682 10 14.6667 10.2985 14.6667 10.6667V13.3333C14.6667 14.0697 14.0697 14.6667 13.3333 14.6667H10.6667C10.2985 14.6667 10 14.3682 10 14C10 13.6318 10.2985 13.3333 10.6667 13.3333H12.3905L8.19526 9.13807C7.93491 8.87772 7.93491 8.45561 8.19526 8.19526C8.45561 7.93491 8.87772 7.93491 9.13807 8.19526L13.3333 12.3905V10.6667Z" fill="#3C5873" />
        <path d="M13.3333 4C13.3333 4.36819 13.6318 4.66667 14 4.66667C14.3682 4.66667 14.6667 4.36819 14.6667 4V1.33333C14.6667 0.596954 14.0697 0 13.3333 0H10.6667C10.2985 0 10 0.298477 10 0.666667C10 1.03486 10.2985 1.33333 10.6667 1.33333H12.3905L8.19526 5.52859C7.93491 5.78894 7.93491 6.21105 8.19526 6.4714C8.45561 6.73175 8.87772 6.73175 9.13807 6.4714L13.3333 2.27614V4Z" fill="#3C5873" />
        <path d="M1.33333 10.6667C1.33333 10.2985 1.03486 10 0.666667 10C0.298477 10 0 10.2985 0 10.6667V13.3333C0 14.0697 0.596954 14.6667 1.33333 14.6667H4C4.36819 14.6667 4.66667 14.3682 4.66667 14C4.66667 13.6318 4.36819 13.3333 4 13.3333H2.27614L6.4714 9.13807C6.73175 8.87772 6.73175 8.45561 6.4714 8.19526C6.21105 7.93491 5.78894 7.93491 5.52859 8.19526L1.33333 12.3905V10.6667Z" fill="#3C5873" />
      </svg>
    </span>
  );
}

FullScreenIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};
